import { default as __nuxt_component_0 } from "/opt/build/repo/components/Common/InfoTooltip.vue";
import { default as __nuxt_component_1 } from "/opt/build/repo/components/Common/TextInfo.vue";
import { default as __nuxt_component_2 } from "/opt/build/repo/components/App/Drawer.vue";
"use strict";
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "pt-6 border-t relative" };
const _hoisted_2 = { class: "flex justify-between text-sm" };
const _hoisted_3 = {
  class: "font-mono flex items-start break-all",
  "data-cy": "trading-page-details-total-text-content"
};
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("span", { class: "mr-1" }, "\u2248", -1);
const _hoisted_5 = { class: "text-gray-500 ml-1 break-normal" };
const _hoisted_6 = { class: "mt-4" };
const _hoisted_7 = {
  key: 0,
  "data-cy": "trading-page-details-minimum-amount-text-content",
  class: "font-mono flex items-start break-all"
};
const _hoisted_8 = { class: "text-gray-500 ml-1 break-normal" };
const _hoisted_9 = {
  key: 1,
  class: "text-gray-500 ml-1"
};
const _hoisted_10 = {
  key: 0,
  "data-cy": "trading-page-details-execution-price-text-content",
  class: "font-mono flex items-start break-all"
};
const _hoisted_11 = { class: "text-gray-500 ml-1 break-normal" };
const _hoisted_12 = {
  key: 1,
  class: "text-gray-500 ml-1"
};
import { ZERO_IN_BASE } from "@injectivelabs/sdk-ui-ts";
export default /* @__PURE__ */ _defineComponent({
  __name: "OrderDetails",
  props: {
    isBuy: Boolean,
    executionPrice: {
      type: Object,
      required: true
    },
    market: {
      type: Object,
      required: true
    },
    minimumReceivedAmount: {
      type: Object,
      default: ZERO_IN_BASE
    }
  },
  setup(__props) {
    const formValues = useFormValues();
    const { tradingTypeMarket } = useSpotFormFormatter(formValues);
    return (_ctx, _cache) => {
      const _component_CommonInfoTooltip = __nuxt_component_0;
      const _component_CommonTextInfo = __nuxt_component_1;
      const _component_AppDrawer = __nuxt_component_2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppDrawer, null, {
          header: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, [
              _createVNode(_component_CommonTextInfo, {
                title: _ctx.$t("trade.total"),
                lg: ""
              }, _createSlots({
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    _hoisted_4,
                    _renderSlot(_ctx.$slots, "total"),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.market.quoteToken.symbol), 1)
                  ])
                ]),
                _: 2
              }, [
                _unref(tradingTypeMarket) ? {
                  name: "context",
                  fn: _withCtx(() => [
                    _createVNode(_component_CommonInfoTooltip, {
                      class: "ml-2",
                      tooltip: _ctx.$t("trade.market_total_tooltip")
                    }, null, 8, ["tooltip"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["title"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _unref(tradingTypeMarket) ? (_openBlock(), _createBlock(_component_CommonTextInfo, {
                key: 0,
                class: "mt-2",
                title: _ctx.$t("trade.amount")
              }, {
                context: _withCtx(() => [
                  _createVNode(_component_CommonInfoTooltip, {
                    class: "ml-2",
                    tooltip: _ctx.$t("trade.min_received_amount")
                  }, null, 8, ["tooltip"])
                ]),
                default: _withCtx(() => [
                  __props.minimumReceivedAmount.gt(0) ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "marketMinimumReceivedAmount"),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(__props.isBuy ? __props.market.baseToken.symbol : __props.market.quoteToken.symbol), 1)
                  ])) : (_openBlock(), _createElementBlock("span", _hoisted_9, " \u2014 "))
                ]),
                _: 3
              }, 8, ["title"])) : _createCommentVNode("", true),
              _createVNode(_component_CommonTextInfo, {
                title: _ctx.$t("trade.price"),
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  __props.executionPrice.gt(0) ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "executionPrice"),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(__props.market.quoteToken.symbol), 1)
                  ])) : (_openBlock(), _createElementBlock("span", _hoisted_12, " \u2014 "))
                ]),
                _: 3
              }, 8, ["title"]),
              _renderSlot(_ctx.$slots, "makerTakerFeeRate"),
              _renderSlot(_ctx.$slots, "feeRate"),
              !_unref(tradingTypeMarket) ? _renderSlot(_ctx.$slots, "feeRebate", { key: 1 }) : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "expectedPts")
            ])
          ]),
          _: 3
        })
      ]);
    };
  }
});
